// @flow
import moment from 'moment-timezone'

import { type StateDataCurrent } from 'app/common/ui-components/filter'

export const dateFormat = 'YYYY-MM-DD'

type Item = { id: string, title: string }

const items = [
  {
    id: 'current',
    title: 'Текущее состояние',
  },

  {
    id: 'date',
    title: 'Выбор даты %date%',
  },
]

const currentStateDateItems = async (): [Array<Item>, StateDataCurrent] => {
  return [items, ['current', moment().format(dateFormat)]]
}

export default currentStateDateItems
